"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "FormattedHTMLMessage", {
  enumerable: true,
  get: function get() {
    return _FormattedHTMLMessage.default;
  }
});
Object.defineProperty(exports, "FormattedMessage", {
  enumerable: true,
  get: function get() {
    return _FormattedMessage.default;
  }
});
Object.defineProperty(exports, "FormattedReactMessage", {
  enumerable: true,
  get: function get() {
    return _FormattedReactMessage.default;
  }
});
Object.defineProperty(exports, "FormattedList", {
  enumerable: true,
  get: function get() {
    return _FormattedList.default;
  }
});
Object.defineProperty(exports, "FormattedDateTime", {
  enumerable: true,
  get: function get() {
    return _FormattedDateTime.default;
  }
});
Object.defineProperty(exports, "FormattedNumber", {
  enumerable: true,
  get: function get() {
    return _FormattedNumber.default;
  }
});
Object.defineProperty(exports, "FormattedRelative", {
  enumerable: true,
  get: function get() {
    return _FormattedRelative.default;
  }
});
Object.defineProperty(exports, "FormattedPercentage", {
  enumerable: true,
  get: function get() {
    return _FormattedPercentage.default;
  }
});
Object.defineProperty(exports, "FormattedCurrency", {
  enumerable: true,
  get: function get() {
    return _FormattedCurrency.default;
  }
});
Object.defineProperty(exports, "FormattedName", {
  enumerable: true,
  get: function get() {
    return _FormattedName.default;
  }
});
Object.defineProperty(exports, "FormattedPhoneNumber", {
  enumerable: true,
  get: function get() {
    return _FormattedPhoneNumber.default;
  }
});

var _FormattedHTMLMessage = _interopRequireDefault(require("./FormattedHTMLMessage"));

var _FormattedMessage = _interopRequireDefault(require("./FormattedMessage"));

var _FormattedReactMessage = _interopRequireDefault(require("./FormattedReactMessage"));

var _FormattedList = _interopRequireDefault(require("./FormattedList"));

var _FormattedDateTime = _interopRequireDefault(require("./FormattedDateTime"));

var _FormattedNumber = _interopRequireDefault(require("./FormattedNumber"));

var _FormattedRelative = _interopRequireDefault(require("./FormattedRelative"));

var _FormattedPercentage = _interopRequireDefault(require("./FormattedPercentage"));

var _FormattedCurrency = _interopRequireDefault(require("./FormattedCurrency"));

var _FormattedName = _interopRequireDefault(require("./FormattedName"));

var _FormattedPhoneNumber = _interopRequireDefault(require("./FormattedPhoneNumber"));

console.warn('Do not import from I18n/components. Import the component directly.');